import { BaseError, UserRejectedRequestError } from 'viem';

type ErrorWithCode<T = number> = {
  code: T;
} & Error;

export function isErrorWithCode<T>(e: any): e is ErrorWithCode<T> {
  return (e as ErrorWithCode).code != null;
}

export const isViemBaseError = (error: BaseError): error is BaseError =>
  !!error.walk && !!error.walk((e) => e instanceof BaseError);

export const isUserRejectedError = (
  error: BaseError
): error is UserRejectedRequestError =>
  !!error.walk && !!error.walk((e) => e instanceof UserRejectedRequestError);
